<template>
  <v-row class="text--primary">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Produtos
        </v-subheader>
        <v-divider/>
        <px-aprovacao-solicitacao-produtos-table :aprovacao="aprovacao"
                                                 @update="emitUpdate"/>
      </v-card>
    </v-col>
    <px-confirm-dialog ref="confirmCancelar"/>
    <px-confirm-dialog ref="confirmFinalizar"/>
  </v-row>
</template>

<script>
import AprovacaoSolicitacaoProdutosTable
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoProdutosTable.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxAprovacaoSolicitacaoProdutosTable: AprovacaoSolicitacaoProdutosTable,
  },
};
</script>
